module.exports = __webpack_public_path__ + "static/media/comingsoon.befd4623.jpg";